import React from 'react';
import PropTypes from 'prop-types';

import './form-tile-footer.scss';
import classnames from 'classnames';

export class FormTileFooter extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    fixed: PropTypes.bool,
  };

  static defaultProps = {
    children: null,
    fixed: false,
  };

  render() {
    const { children, fixed } = this.props;

    return (
      <div className={classnames('form-tile-footer', { _fixed: fixed })}>
        {children}
      </div>
    );
  }
}
FormTileFooter.displayName = 'FormTileFooter';
